<template>
      <div class="formIndex">
        <div class="title">
          <p>* 请确保以下填写信息真实有效</p>
        </div>
        <div class="userName">
          <span><small style="color: red">*</small> 姓名</span>
          <el-input placeholder="填写受检人姓名"
                    v-model="userName"
                    clearable
                    size="small"
                    style="width: 65%;margin-right: 8px;">
          </el-input>
        </div>
        <div class="idCardType">
          <span style="flex:4"><small style="color: red">*</small> 证件类型</span>
          <div class="idCardTypeRadio">
            <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="居民身份证">居民身份证</el-radio>
            <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="其他">其他</el-radio>
          </div>
        </div>
        <div class="idCard">
          <span><small style="color: red">*</small> 证件号码</span>
          <el-input placeholder="填写受检人证件号码"
                    v-model="idCard"
                    clearable
                    size="small"
                    @input="idCardChange"
                    @change="idCardChangeValue"
                    style="width: 65%;margin-right: 10px">
          </el-input>
        </div>
        <div class="country" v-if="idCardTypeRadio === '其他'">
          <van-field label="国籍"
                     required
                     :value="country"
                     readonly is-link
                     @click="showCountrySelector"
                     placeholder="请选择国籍"/>
          <van-popup v-model="isShowCountrySelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="国籍"
              show-toolbar
              :columns="countryOptions"
              @confirm="onConfirmCountry"
              @cancel="onCancelCountry"
            />
          </van-popup>
        </div>
        <div class="sex"  v-if="idCardTypeRadio === '其他'">
          <span style="flex:4"><small style="color: red">*</small> 性别</span>
          <div class="sexRadio">
            <el-radio v-model="sexRadio" label="男">男</el-radio>
            <el-radio v-model="sexRadio" label="女">女</el-radio>
          </div>
        </div>
        <div class="birthday"  v-if="idCardTypeRadio === '其他'">
          <van-field label="出生日期"
                     required
                     :value="birthday"
                     readonly is-link
                     @click="showBirthdayPicker"
                     placeholder="选择出生年月日"/>
          <van-popup v-model="isShowBirthdayPicker" position="bottom" :style="{ height: '40%' }">
            <van-datetime-picker
              v-model="choicBirthday"
              type="date"
              title="选择年月日"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="confirmBirthdayPicker"
              @cancel="cancelBirthdayPicker"
            />
          </van-popup>
        </div>
        <div class="phone">
          <span><small style="color: red">*</small> 手机号</span>
          <el-input placeholder="填写手机号，仅用于报告通知"
                    type="number" pattern="\d*"
                    v-model="phone"
                    clearable
                    size="small"
                    style="width: 65%;margin-right: 10px">
          </el-input>
        </div>
<!--        <div class="Residence">-->
<!--          <span><small style="color: red">*</small> 单位名称</span>-->
<!--          <el-input placeholder="填写所在单位名称"-->
<!--                    v-model="Residence"-->
<!--                    clearable-->
<!--                    size="small"-->
<!--                    style="width: 65%;margin-right: 10px">-->
<!--          </el-input>-->
<!--        </div>-->
        <div class="personType">
          <span>人员类型</span>
          <el-input v-model="personType"
                    placeholder="填写人员类型"
                    clearable
                    maxlength="64"
                    size="small"
                    style="width: 65%;margin-right: 10px">
          </el-input>

          <!--          <van-field label="人员类型"-->
<!--                     required-->
<!--                     :value="personType"-->
<!--                     readonly is-link-->
<!--                     @click="showPersonTypeSelector"-->
<!--                     placeholder="选择人员类型"/>-->
<!--          <van-popup v-model="isShowPersonType" position="bottom" :style="{ height: '40%' }">-->
<!--            <van-picker-->
<!--              title="人员类型"-->
<!--              show-toolbar-->
<!--              default-index="1"-->
<!--              :columns="personTypeOptions"-->
<!--              @confirm="onConfirmPersonType"-->
<!--              @cancel="onCancelPersonType"-->
<!--            />-->
<!--          </van-popup>-->
        </div>
        <div class="remarks">
          <span>备注</span>
          <el-input v-model="remarks"
                    placeholder="添加备注信息"
                    clearable
                    size="small"
                    style="width: 65%;margin-right: 10px">
          </el-input>
        </div>


        <div class="age" style="display: none">
          <span>年龄</span>
          <el-input placeholder="请输入您的真实年龄"
                    v-model="age"
                    clearable
                    style="width: 65%;margin-right: 10px">
          </el-input>
        </div>
        <div class="notice">
          <el-checkbox v-model="checkNotice">
            我已阅读并同意
          </el-checkbox>
          <span class="noticeBook" @click="showDialogBtn">《知情通知书》</span>
        </div>
        <div class="modal-mask" @click="hideModal"  v-if="showModel" @touchmove.prevent></div>
        <div class="modal-dialog" v-if="showModel">

          <div class="modal-title">知情同意书</div>
          <div class="modal-content">
            <p>
            致核子华曦医学检验实验室（以下简称“检测机构”）： <br><br>
            受检人知悉并同意如下事项：<br> 
            <br>
            1.由于检测技术的局限性，阴性核酸检测结果不完全排除感染2019-nCoV的可能，不排除部分检测中出现假阳性或假阴性的可能。
             <br>2.极少数样品的采样方法不恰当、采样体积不足，或样品转运、储存等存在问题影响送检样品质量，可能影响检测结果的准确性。
             <br>3.本实验室所出具的检测结果只针对此样本负责。
             <br><br>
             受检者声明 <br><br>
             1.本人在填写《送检申请单》时将如实提供本人的个人信息，若本人存在如发热等2019-nCoV感染相关症状及涉疫地区旅居史和接触、暴露史的，将如实在《送检申请单》中披露。
             <br>2.本人将在检测机构工作人员指导下正确采集并提供合格样本，取样过程中本人将注意防护，佩戴口罩以避免飞沫传播风险，勤洗手或者用75%酒精消毒以避免接触传播风险。
             <br>3.本人授权检测机构对检测涉及的样品进行处理，包括样品和医疗废弃物等。在符合法律法规前提下，本人授权检测机构将本人检测完毕后的剩余样品用于经检测机构伦理委员会审查批准的科学研究、技术开发、临床应用或药物试验等，并允许检测机构通过相关实验数据获得相关的知识产权。
             <br>4.本人已知晓本次检测仅对此次送检样本负责，且检测结果仅供筛查使用，不作为临床确诊的依据，相关解释需咨询临床医生。
             <br><br>
             受检人承诺 <br>
             <br>本人承诺《送检申请单》中提供的信息完整真实，确认已阅读、知晓、充分理解并同意上述全部内容，且检测机构已向本人完全告知本次检测性质、预期目的和相关风险。本人自愿进行本次检测，并承担检测带来的相关风险。
          </p>
          </div>
          <div class="modal-footer">
            <div class="btn-confirm" @click="hideModal" data-status="confirm">确定</div>
          </div>

        </div>
        <div class="submit">
          <el-button type="primary"
                     :disabled="isClick"
                     @click="submit"
                     style="width: 65%;margin-top: 20px">
            提交</el-button>
        </div>
      </div>
</template>

<script>
    import  storage from '../../model/storage.js'
    export default {
        name: "sjzFormIndex",
        data() {
          return {
            isShowPersonType: false,
            countryOptions: [
              "中国",
              "中国香港",
              "中国澳门",
              "中国台湾",
              "韩国",
              "日本",
              "意大利",
              "西班牙",
              "法国",
              "德国",
              "美国",
              "加拿大",
              "新加坡",
              "马来西亚",
              "巴林",
              "阿联酋",
              "瑞士",
              "荷兰",
              "英国",
              "瑞典",
              "澳大利亚",
              "新西兰",
              "巴西",
              "阿根廷",
              "伊朗",
              "阿富汗",
              "阿尔巴尼亚",
              "南极洲",
              "阿尔及利亚",
              "美属萨摩亚",
              "安道尔",
              "安哥拉",
              "安提瓜和巴布达",
              "阿塞拜疆",
              "奥地利",
              "巴哈马",
              "孟加拉国",
              "亚美尼亚",
              "巴勒斯坦",
              "巴巴多斯",
              "比利时",
              "百慕大",
              "不丹",
              "玻利维亚",
              "波黑",
              "博茨瓦纳",
              "布维岛",
              "伯利兹",
              "英属印度洋领地",
              "所罗门群岛",
              "英属维尔京群岛",
              "文莱",
              "保加利亚",
              "缅甸",
              "布隆迪",
              "白俄罗斯",
              "柬埔寨",
              "喀麦隆",
              "佛得角",
              "开曼群岛",
              "中非",
              "斯里兰卡",
              "乍得",
              "智利",
              "圣诞岛",
              "科科斯（基林）群岛",
              "哥伦比亚",
              "科摩罗",
              "马约特",
              "刚果（布）",
              "刚果（金）",
              "库克群岛",
              "哥斯达黎加",
              "克罗地亚",
              "古巴",
              "塞浦路斯",
              "捷克",
              "贝宁",
              "丹麦",
              "多米尼克",
              "多米尼加",
              "厄瓜多尔",
              "萨尔瓦多",
              "赤道几内亚",
              "埃塞俄比亚",
              "厄立特里亚",
              "爱沙尼亚",
              "法罗群岛",
              "福克兰群岛（马尔维纳斯群岛）",
              "南乔治亚岛和南桑德韦奇岛",
              "斐济",
              "芬兰",
              "奥兰群岛",
              "法属圭亚那",
              "法属波利尼西亚",
              "法属南部领地",
              "吉布提",
              "加蓬",
              "格鲁吉亚",
              "冈比亚",
              "加纳",
              "直布罗陀",
              "基里巴斯",
              "希腊",
              "格陵兰",
              "格林纳达",
              "瓜德罗普",
              "关岛",
              "危地马拉",
              "几内亚",
              "圭亚那",
              "海地",
              "赫德岛和麦克唐纳岛",
              "梵蒂冈",
              "洪都拉斯",
              "匈牙利",
              "冰岛",
              "印度",
              "印度尼西亚",
              "伊拉克",
              "爱尔兰",
              "以色列",
              "科特迪瓦",
              "牙买加",
              "哈萨克斯坦",
              "约旦",
              "肯尼亚",
              "朝鲜",
              "科威特",
              "吉尔吉斯斯坦",
              "老挝",
              "黎巴嫩",
              "莱索托",
              "拉脱维亚",
              "利比里亚",
              "利比亚",
              "列支敦士登",
              "立陶宛",
              "卢森堡",
              "马达加斯加",
              "马拉维",
              "马尔代夫",
              "马里",
              "马耳他",
              "马提尼克",
              "毛里塔尼亚",
              "毛里求斯",
              "墨西哥",
              "摩纳哥",
              "蒙古",
              "摩尔多瓦",
              "黑山",
              "蒙特塞拉特",
              "摩洛哥",
              "莫桑比克",
              "阿曼",
              "纳米比亚",
              "瑙鲁",
              "尼泊尔",
              "荷属安的列斯",
              "阿鲁巴",
              "新喀里多尼亚",
              "瓦努阿图",
              "尼加拉瓜",
              "尼日尔",
              "尼日利亚",
              "纽埃",
              "诺福克岛",
              "挪威",
              "北马里亚纳",
              "美国本土外小岛屿",
              "密克罗尼西亚",
              "马绍尔群岛",
              "帕劳",
              "巴基斯坦",
              "巴拿马",
              "巴布亚新几内亚",
              "巴拉圭",
              "秘鲁",
              "菲律宾",
              "皮特凯恩群岛",
              "波兰",
              "葡萄牙",
              "几内亚比绍",
              "东帝汶",
              "波多黎各",
              "卡塔尔",
              "留尼汪",
              "罗马尼亚",
              "俄罗斯",
              "卢旺达",
              "圣赫勒拿",
              "圣基茨和尼维斯",
              "安圭拉",
              "圣卢西亚",
              "圣皮埃尔和密克隆",
              "圣文森特和格林纳丁斯",
              "圣马力诺",
              "圣多美和普林西比",
              "沙特阿拉伯",
              "塞内加尔",
              "塞尔维亚",
              "塞舌尔",
              "塞拉利昂",
              "斯洛伐克",
              "越南",
              "斯洛文尼亚",
              "索马里",
              "南非",
              "津巴布韦",
              "西撒哈拉",
              "苏丹",
              "苏里南",
              "斯瓦尔巴岛和扬马延岛",
              "斯威士兰",
              "叙利亚",
              "塔吉克斯坦",
              "泰国",
              "多哥",
              "托克劳",
              "汤加",
              "特立尼达和多巴哥",
              "突尼斯",
              "土耳其",
              "土库曼斯坦",
              "特克斯和凯科斯群岛",
              "图瓦卢",
              "乌干达",
              "乌克兰",
              "北马其顿",
              "埃及",
              "格恩西岛",
              "泽西岛",
              "英国属地曼岛",
              "坦桑尼亚",
              "美属维尔京群岛",
              "布基纳法索",
              "乌拉圭",
              "乌兹别克斯坦",
              "委内瑞拉",
              "瓦里斯和福图纳",
              "萨摩亚",
              "也门",
              "赞比亚"
            ],
            isShowCountrySelector: false,
            idCardTypeOptions: [
              '居民身份证',
              '护照',
              '港澳居民来往内地通行证（俗称回乡证）',
              '台湾居民来往内地通行证（俗称台胞证）',
              '出生医学证明',
              '其他'
            ],
            country: '中国',
            idCardType: '居民身份证',
            idCard: '',
            userName: '',
            sexRadio: '男',
            age: '',
            birthday: '',
            choicBirthday: new Date(1980, 0, 1),
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(),
            phone: '',
            remarks: '',
            isClick: false,
            checkNotice: false,
            showModel: false,
            idCardTypeRadio: '居民身份证',
            Residence: '无',
            personType: '',
            personTypeOptions: [
              '餐饮单位从业人员',
              '商场超市从业人员',
              '餐饮外卖、生活物资物流配送服务的从业人员',
              '零售药店从业人员',
              '冷库、冷链物流企业（仅包含贮存进口产品的企业）的从业人员',
              '食品生产经营单位直接接触进口冷链食品的从业人员',
              '农贸市场（含农批市场）从业人员',
              '文体旅游',
              '交通运输'
            ],
            isShowBirthdayPicker: false
          }
        },
        created() {
          let sjzUserData = storage.get('sjzUserData')
          let on = this.$route.query.on
          if (on === 1 || on === '1') {
            return
          }
          if(sjzUserData && sjzUserData.length === 1) {
            this.$router.push({
              path: '/sjz_code',
              query: {
                index: 0
              }
            })
          }else if(sjzUserData && sjzUserData.length > 1) {
            this.$router.push({
              path: '/sjz_list'
            })
          }
        },
        methods: {
          confirmBirthdayPicker(e) {
            let now_date = e
            let Y = now_date.getFullYear()
            let M = (now_date.getMonth() + 1 < 10 ? '0' + (now_date.getMonth() + 1) : now_date.getMonth() + 1)
            let D = (now_date.getDate() < 10 ? '0' + now_date.getDate() : now_date.getDate())
            now_date = Y + '-' + M + '-' + D
            this.birthday = now_date

            let yearBirth = now_date.substring(0, 4);
            let monthBirth = now_date.substring(5, 7);
            let dayBirth = now_date.substring(8, 10);
            // 获取当前年月日并计算年龄
            let myDate = new Date();
            let monthNow = myDate.getMonth() + 1;
            let dayNow = myDate.getDay();
            let age = myDate.getFullYear() - yearBirth;
            if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
              age--;
            }
            // 得到年龄
            this.age = age;
            console.log(this.age)


            this.isShowBirthdayPicker = false
          },
          cancelBirthdayPicker() {
            this.isShowBirthdayPicker = false
          },
          showBirthdayPicker() {
            this.isShowBirthdayPicker = true
          },
          showCountrySelector() {
            this.isShowCountrySelector = true
          },
          onConfirmCountry(e) {
            this.country = e
            if(this.country !== '中国') {
              this.idCardType = '其他'
            }

            this.isShowCountrySelector = false
          },
          onCancelCountry() {
            this.isShowCountrySelector = false
          },
          showPersonTypeSelector() {
            this.isShowPersonType = true
          },
          onConfirmPersonType(e) {
            this.personType = e
            this.isShowPersonType = false
          },
          onCancelPersonType() {
            this.isShowPersonType = false
          },
          countryChange(country) {
            if(country !== '中国') {
              this.idCardType = '其他'
            }

          },
          idCardTypeChange(idCardType) {

            this.idCardType = idCardType

            if(idCardType  === '居民身份证') {
              this.country = '中国'
              this.idCardComputed()
            }
          },
          birthdayChange(birthday) {
            let yearBirth = birthday.substring(0, 4);
            let monthBirth = birthday.substring(5, 7);
            let dayBirth = birthday.substring(8, 10);
            // 获取当前年月日并计算年龄
            let myDate = new Date();
            let monthNow = myDate.getMonth() + 1;
            let dayNow = myDate.getDay();
            let age = myDate.getFullYear() - yearBirth;
            if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
              age--;
            }
            // 得到年龄
            this.age = age;
            console.log(this.age)
          },
          idCardComputed() {
            if(this.idCard.length >= 18 && this.idCardType === '居民身份证') {
              let idCard = this.idCard.substr(0,18).toUpperCase()
              this.idCard = idCard
              console.log(idCard)
              if(this.idCardType === "居民身份证" && !this.id_card_mix(idCard)) {
                // this.$message.error('请核实身份证信息')
                console.log('请核实身份证信息')
                return;
              }
              console.log('过了校验')

              const agesex = this.analyzeIDCard(this.idCard);
              console.log(agesex)
              if (agesex.sex === '男') {
                this.sexRadio = '男'
              }else {
                this.sexRadio = '女'
              }
              this.age = agesex.age
              this.sexRadio = agesex.sex
              this.birthday = agesex.birthday
            }
          },
          idCardChange(value) {
            console.log("idCardChange",value)
            let idCardType = this.idCardType
            // console.log(idCardType)
            if(value.length >= 18 && idCardType === '居民身份证') {
              let idCard = value.substr(0,18).toUpperCase()
              this.idCard = idCard
              console.log(idCard)
              if(idCardType === "居民身份证" && !this.id_card_mix(idCard)) {
                // this.$message.error('请核实身份证信息')
                console.log('请核实身份证信息')
                return;
              }
              console.log('过了校验')

              const agesex = this.analyzeIDCard(value);
              console.log(agesex)
              if (agesex.sex == '男') {
                this.sexRadio = '男'
              }else {
                this.sexRadio = '女'
              }
              this.age = agesex.age
              this.sexRadio = agesex.sex
              this.birthday = agesex.birthday
            }
          },
          idCardChangeValue() {
            if(this.idCardType == "居民身份证" && !this.id_card_mix(this.idCard)) {
              this.$message.error('请核实身份证信息');
              return;
            }
          },
          showDialogBtn() {
            this.showModel = true
          },
          hideModal() {
            this.showModel = false
          },
          submit() {
            this.isClick = true
            const userDataItem = {}
            userDataItem['country'] = this.country
            userDataItem['idCardType'] = this.idCardTypeRadio
            userDataItem['idCard'] = this.idCard
            userDataItem['userName'] = this.userName
            userDataItem['sexRadio'] = this.sexRadio
            userDataItem['age'] = this.age
            userDataItem['birthday'] = this.birthday
            userDataItem['phone'] = this.phone,
            userDataItem['personType'] = this.personType,
            userDataItem['Residence'] = this.Residence,
            userDataItem['remarks'] = this.remarks


            let _this = this
            if(this.msgCheck(userDataItem)) {
              this.$message.error({
                message: this.msgCheck(userDataItem),
                duration: 2000,
                onClose() {
                  _this.isClick = false
                }
              })

              return;
            }

            console.log(userDataItem)
            console.log(this.userData)

            if(this.checkNotice === false) {
              this.$message.error({
                message: '请先确认知情同意书',
                duration: 2000,
                onClose() {
                  _this.isClick = false
                }
              })

              return;
            }

            //获取缓存数据
            let sjzUserData = storage.get('sjzUserData') ? storage.get('sjzUserData') : []
            sjzUserData.unshift(userDataItem)
            storage.set('sjzUserData',sjzUserData)

            sjzUserData = storage.get('sjzUserData') ? storage.get('sjzUserData') : []
            // let index = sjzUserData.length -1
            let index = 0


            if(sjzUserData && sjzUserData.length === 1) {
              this.$router.push({
                path: '/sjz_code',
                name: 'sjzCodePage',
                query: {
                  index: index
                }
              });
            }
            if(sjzUserData && sjzUserData.length > 1) {
              this.$router.push({
                path: '/sjz_list',
                name: 'sjzList',
              });
            }
          },
          id_card_mix(code){
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            var tip = "";
            var pass = true;
            var reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
            if (!code || !code.match(reg)) {
              tip = "身份证号格式错误";
              pass = false;
            }else if (!city[code.substr(0, 2)]) {
              tip = "地址编码错误";
              pass = false;
            }else {
              //18位身份证需要验证最后一位校验位
              if (code.length == 18) {
                code = code.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                  ai = code[i];
                  wi = factor[i];
                  sum += ai * wi;
                }
                var last = parity[sum % 11];
                if (parity[sum % 11] != code[17]) {
                  tip = "校验位错误";
                  pass = false;
                }
              }
            }

            if(pass) return true;
            return false;
          },
          analyzeIDCard(IDCard) {
            let sexAndAge = {};
            // 获取用户身份证号码
            let userCard = IDCard;
            // 如果身份证号码为 undefind 则返回空
            if (!userCard) {
              return sexAndAge;
            }
            // 获取性别
            if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
              sexAndAge.sex = '男'
            } else {
              sexAndAge.sex = '女'
            }
            // 获取出生年月日
            //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
            let yearBirth = userCard.substring(6, 10);
            let monthBirth = userCard.substring(10, 12);
            let dayBirth = userCard.substring(12, 14);
            let birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
            // 获取当前年月日并计算年龄
            let myDate = new Date();
            let monthNow = myDate.getMonth() + 1;
            let dayNow = myDate.getDay();
            let age = myDate.getFullYear() - yearBirth;
            if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
              age--;
            }
            //得到出生日期
            sexAndAge.birthday = birthday;
            // 得到年龄
            sexAndAge.age = age;
            // 返回性别和年龄
            return sexAndAge;
          },
          msgCheck(data) {
            var role=/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|30|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
            if(!data.userName) return '请输入姓名'
            if(!data.idCard) return '请输入证件号码'
            if(data.idCardType === "居民身份证"&&!this.id_card_mix(data.idCard)) return '身份证可能有误，请确认填写无误'
            if(!data.country) return '请选择国籍'
            if(!data.sexRadio) return '请输入性别'

            if(this.idCardType === '其他' && !data.birthday) return '请输入出生日期'
            if(!data.phone) return '请输入手机号'
            // if(!data.Residence) return '请输入单位名称'
            if(!/^1[3456789]\d{9}$/.test(data.phone)) return '手机格式错误'
            return ;
          },
      }
    }
</script>

<style scoped>
  .userName>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .idCard>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .country>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .birthday>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .phone>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .personType>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .Residence>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .remarks>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .title {
    margin-top: 20px;
    padding-left: 10px
  }
  .title p {
    margin-top: -10px;
    font-size: 18px;
    color: #f0b27f;
  }
  .country,
  .idCardType,
  .idCard,
  .sex,
  .age,
  .userName,
  .birthday,
  .phone,
  .remarks,
  .notice,
  .Residence,
  .personType{
    display: flex;
    justify-content: space-between;
    height: 42px;
    border-bottom: 1px solid #f1f4f8;
  }
  .userName>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .idCard>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .birthday>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .phone>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .personType>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .personType>>>.van-field__label {
    font-size: 1.1rem;
    white-space:nowrap;
    color: black;
  }
  .personType>>>.van-field__control {
    font-size: 1.1rem;
  }
  .personType>>>.van-field__control::-webkit-input-placeholder {
    font-size: 14px;
  }

  .birthday>>>.van-field__label {
    font-size: 1.1rem;
    white-space:nowrap;
    color: black;

  }
  .birthday>>>.van-field__control {
    font-size: 1.1rem;
  }
  .birthday>>>.van-field__control::-webkit-input-placeholder {
    font-size: 14px;
  }

  .country>>>.van-field__label {
    font-size: 1.1rem;
    white-space:nowrap;
    color: black;

  }
  .country>>>.van-field__control {
    font-size: 1.1rem;
  }
  .personType>>>.van-ellipsis {
    white-space: normal;
    text-align: center;
  }
  .Residence>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .remarks>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }


  span{
    font-size: 1.1rem;
    height: 42px;
    line-height: 42px;
    padding: 0 10px;
    white-space:nowrap;
  }

  .sexRadio,
  .idCardTypeRadio{
    flex: 10;
    display: flex;
    align-items: center;
    height: 42px;
    padding-left: 15px;
  }
  .idCardTypeRadio>>>.el-radio__label{
    font-size: 1.1rem;
    margin-left: -6px;
  }
  .sexRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }
  .submit{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice {
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content:flex-start;
    margin-top: 10px;
    border: 0;
  }
  .noticeBook {
    height: 50px;
    font-size: 13px;
    margin-top: -9px;
    margin-left: -8px;
    color: #6e8fba
  }
  .modal-dialog {
    width: 300px;
    position: fixed;
    top: 40px;
    left: 37px;
    z-index: 99999;
    background: #f9f9f9;
    /* margin: -180px 105rpx;  */
    border-radius: 10px;
  }
  .modal-title {
    padding-top: 10px;
    font-size: 20px;
    color: #030303;
    text-align: center;
  }
  .modal-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.5;
    overflow: hidden;
    z-index: 999;
    color: #fff;
  }
  .modal-content {
    padding: 8px 20px;
    overflow: auto;
    height: 450px;
    line-height: 22px;
  }
  .modal-footer {
    display: flex;
    flex-direction: row;
    height: 40px;
    border-top: 1px solid #dedede;
    font-size: 16px;
    line-height: 40px;
  }
  .btn-confirm {
    width: 100%;
    color: #3897f0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/sjz/sjzFormIndex.vue